import React, { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import Lgpd from '../../Lgpd';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import FiltroComunicados from '../../Filtros/FiltroComunicados';
import InfoComponent from '../InfoComponent';

class PerfilDeInvestimento extends Component {
	render() {
		return (
			<div>
				{/* 
				é uma copia do Perfil de Investimento B, sendo que vai servir para todos perfils (B e Taesa)... foi removido os links de Perfil do Plano B e Plano Taesa
				*/}
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>

					<InfoComponent image={"planoBInvestimento"} page={'planoBInvestimento'}></InfoComponent>

					{/* Content page */}
					<ErrorBoundary><FiltroComunicados url={"/ObterInvestimentosPerfil"} urlFiltro={"/ObterInvestimentosPerfil?"} /></ErrorBoundary>
				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default PerfilDeInvestimento;